import * as React from "react";
import { ServiceProviderTemplate } from "../../../template/service-provider/default-template";
import { Loader } from "../../../organisms/common/loading";
import { useModal } from "../../../../utils/custom-hooks";
import { useMount } from "../../../../utils/custom-hooks";
import { useHistory } from "react-router-dom";
import {
  OrganizationBasicInfoService,
  OrganizationBasicInfoServiceProps,
} from "../../../../application/service/service-provider/basic-info-service";
import { connectPageService } from "../../../../application/domain/base/base-application-service";
import { OrganizationBasicInfoCreateModal } from "../../../organisms/service-provider/modal/organization-basic-info-create-modal";
import { ServiceProviderR } from "../routes";
import { PrimaryButton } from "@graffer-inc/console-design-kit";

export const ServiceProviderHomePage: React.FunctionComponent<
  OrganizationBasicInfoServiceProps
> = ({
  isLoading,
  organizations,
  fetchOrganizations,
  onCreateOrganization,
}) => {
  const history = useHistory();
  const showModal = useModal(false);

  useMount(() => {
    fetchOrganizations();
  });

  return (
    <ServiceProviderTemplate breadcrumbs={[{ to: "#", title: "テナント一覧" }]}>
      <div className="has-text-left">
        <div className="columns">
          <div className="column is-desktop">
            <nav className="level">
              <div className="level-left">
                <div className="level-item">
                  <h1 className="is-size-2">テナント一覧</h1>
                </div>
                <p className="level-item">
                  <PrimaryButton
                    text={"新規登録"}
                    onClick={() => {
                      showModal.open();
                    }}
                  />
                </p>
              </div>
            </nav>
            <Loader isLoading={isLoading}>
              <div className="table-container">
                <table className="table is-fullwidth">
                  <thead>
                    <tr>
                      <th>テナント名</th>
                      <th>スラグ名</th>
                      <th>地方公共団体コード</th>
                    </tr>
                  </thead>
                  <tbody>
                    {organizations.map((org) => (
                      <tr
                        key={org.id}
                        className={"c-tr-selectable"}
                        onClick={() =>
                          history.push(
                            ServiceProviderR.Basic.link({ id: org.id! }),
                          )
                        }
                      >
                        <td>{org.name}</td>
                        <td>{org.slug}</td>
                        <td>{org.localGovCode}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Loader>
            {showModal.isActive && (
              <OrganizationBasicInfoCreateModal
                isLoading={isLoading}
                title={"テナント情報の新規作成"}
                isActive={showModal.isActive}
                onSubmit={onCreateOrganization}
                onModal={showModal.close}
                buttonText={"作成する"}
              />
            )}
          </div>
        </div>
      </div>
    </ServiceProviderTemplate>
  );
};

export const ServiceProviderHomePageContainer = connectPageService(
  ServiceProviderHomePage,
  () => new OrganizationBasicInfoService(),
);
